import React from 'react';
import { TimeZoneProvider } from '@chronosphereio/viz-framework';
import { useUserTimeZone } from '@/context/TimeZone';

export function PersesTimeZoneProvider({ children }: { children: React.ReactNode }) {
  const { timeZone } = useUserTimeZone();
  return <TimeZoneProvider timeZone={timeZone}>{children}</TimeZoneProvider>;
}
